import { useSelector } from "react-redux";
export var useAuthMode = function () { return useSelector(function (state) {
    return state.courseReducer.authMode;
}); };
